import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Uuid")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Name")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Status")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Ready for publication ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Allow marketing by default ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Exclude Digital Classrooms ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Exporting LSP Allowed ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Editable in Self-service ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Organization")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Start date")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("End date")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Invoicing allowed from ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Type")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Maximum members allowed ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Price")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Scheduled Prices")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Minimal length")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Cancel period")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Invoicing period")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Agreement form")
const _hoisted_24 = ["href"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Packages")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Contact Persons")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Agreement additional info")
const _hoisted_29 = { class: "col-auto" }
const _hoisted_30 = { class: "column q-gutter-md" }
const _hoisted_31 = { class: "row q-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_agreements_editable_field_name = _resolveComponent("agreements-editable-field-name")!
  const _component_agreement_status_badge = _resolveComponent("agreement-status-badge")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_agreement_form_field_marketing_communication = _resolveComponent("agreement-form-field-marketing-communication")!
  const _component_agreements_editable_field_exclude_digital_classrooms = _resolveComponent("agreements-editable-field-exclude-digital-classrooms")!
  const _component_agreements_editable_field_lsp_export = _resolveComponent("agreements-editable-field-lsp-export")!
  const _component_agreement_form_field_editable_in_self_service = _resolveComponent("agreement-form-field-editable-in-self-service")!
  const _component_agreements_editable_field_end_date = _resolveComponent("agreements-editable-field-end-date")!
  const _component_agreements_editable_field_invoicing_allowed_from = _resolveComponent("agreements-editable-field-invoicing-allowed-from")!
  const _component_agreements_editable_field_max_members_allowed = _resolveComponent("agreements-editable-field-max-members-allowed")!
  const _component_agreements_editable_field_price = _resolveComponent("agreements-editable-field-price")!
  const _component_agreements_open_dialog_field_scheduled_prices = _resolveComponent("agreements-open-dialog-field-scheduled-prices")!
  const _component_agreements_open_dialog_field_packages = _resolveComponent("agreements-open-dialog-field-packages")!
  const _component_agreements_open_dialog_contact_persons = _resolveComponent("agreements-open-dialog-contact-persons")!
  const _component_agreements_editable_field_additional_info = _resolveComponent("agreements-editable-field-additional-info")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_agreement_update_agreement_management = _resolveComponent("agreement-update-agreement-management")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", null, _toDisplayString(_ctx.agreement.name) + " (" + _toDisplayString(_ctx.agreement.shortId) + ")", 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_list, { class: "q-mb-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.agreement.agreementId), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    (_ctx.agreementModel.status !== 'expired')
                      ? (_openBlock(), _createBlock(_component_agreements_editable_field_name, {
                          key: 0,
                          modelValue: _ctx.agreementModel.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agreementModel.name) = $event))
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createBlock(_component_q_item_section, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.agreementModel.name), 1)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_agreement_status_badge, {
                      status: _ctx.agreementModel.status
                    }, null, 8, ["status"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.agreement.status === 'draft')
              ? (_openBlock(), _createBlock(_component_q_item, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_badge, {
                          color: _ctx.agreement.isReadyForPublication  ? 'positive' : 'negative',
                          label: _ctx.agreement.isReadyForPublication.toString(),
                          class: "self-start"
                        }, null, 8, ["color", "label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_agreement_form_field_marketing_communication, {
                      disable: _ctx.isAgreementExpired,
                      modelValue: _ctx.agreement.allowMarketingCommunication,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.agreement.allowMarketingCommunication) = $event))
                    }, null, 8, ["disable", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_agreements_editable_field_exclude_digital_classrooms, {
                      disable: _ctx.isAgreementExpired,
                      modelValue: _ctx.agreement.excludeDigitalClassrooms,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.agreement.excludeDigitalClassrooms) = $event))
                    }, null, 8, ["disable", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_agreements_editable_field_lsp_export, {
                      disable: _ctx.isAgreementExpired,
                      modelValue: _ctx.agreement.allowLSPExport,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.agreement.allowLSPExport) = $event))
                    }, null, 8, ["disable", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_agreement_form_field_editable_in_self_service, {
                      disable: _ctx.isAgreementExpired,
                      modelValue: _ctx.agreement.editableInSelfService,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.agreement.editableInSelfService) = $event))
                    }, null, 8, ["disable", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.agreement.organization), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.agreement.startDate), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    (_ctx.isAgreementExpired)
                      ? (_openBlock(), _createBlock(_component_q_item_section, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.agreement.endDate), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_agreements_editable_field_end_date, {
                          key: 1,
                          modelValue: _ctx.agreementModel.endDate,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.agreementModel.endDate) = $event))
                        }, null, 8, ["modelValue"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    (_ctx.isAgreementExpired)
                      ? (_openBlock(), _createBlock(_component_q_item_section, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.agreementModel.invoiceAllowedFrom), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_agreements_editable_field_invoicing_allowed_from, {
                          key: 1,
                          modelValue: _ctx.agreementModel.invoiceAllowedFrom,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.agreementModel.invoiceAllowedFrom) = $event))
                        }, null, 8, ["modelValue"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.agreement.type), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.agreementModel.type === _ctx.AgreementType.Total)
              ? (_openBlock(), _createBlock(_component_q_item, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                      default: _withCtx(() => [
                        (_ctx.isAgreementExpired)
                          ? (_openBlock(), _createBlock(_component_q_item_section, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.agreementModel.memberLimit), 1)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_agreements_editable_field_max_members_allowed, {
                              key: 1,
                              modelValue: _ctx.agreementModel.memberLimit,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.agreementModel.memberLimit) = $event))
                            }, null, 8, ["modelValue"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    (_ctx.isAgreementExpired)
                      ? (_openBlock(), _createBlock(_component_q_item_section, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.agreementModel.price) + " €", 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_agreements_editable_field_price, {
                          key: 1,
                          modelValue: _ctx.agreement.price,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.agreement.price) = $event))
                        }, null, 8, ["modelValue"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_agreements_open_dialog_field_scheduled_prices, {
                      agreementScheduledPrices: _ctx.agreementScheduledPrices,
                      agreementInvoicingPeriod: _ctx.agreementModel.invoicingPeriod,
                      onPricesUpdated: _ctx.onPricesUpdated,
                      key: _ctx.scheduledPricesKey
                    }, null, 8, ["agreementScheduledPrices", "agreementInvoicingPeriod", "onPricesUpdated"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.agreement.minLength), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.agreement.cancelPeriod), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.agreement.invoicingPeriod), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.agreementModel.formEnabled)
              ? (_openBlock(), _createBlock(_component_q_item, { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium" }, {
                      default: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                      default: _withCtx(() => [
                        (_ctx.agreementModel.formUrl !== null)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: _ctx.agreementModel.formUrl,
                              target: "_blank",
                              class: "text-primary cursor-pointer"
                            }, _toDisplayString(_ctx.agreementModel.formId), 9, _hoisted_24))
                          : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.agreementModel.formId), 1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium self-start" }, {
                  default: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    (_ctx.isAgreementExpired)
                      ? (_openBlock(), _createBlock(_component_q_item_section, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packageNames, (name, index) => {
                              return (_openBlock(), _createBlock(_component_q_item_section, {
                                class: "block",
                                key: index
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(name), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_agreements_open_dialog_field_packages, {
                          key: 1,
                          agreementPackages: _ctx.packageIds
                        }, null, 8, ["agreementPackages"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium self-start" }, {
                  default: _withCtx(() => [
                    _hoisted_27
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_agreements_open_dialog_contact_persons, {
                      "editing-disabled": _ctx.isAgreementExpired,
                      "agreement-id": _ctx.agreementModel.agreementId,
                      "agreement-contact-persons": _ctx.contactPersons
                    }, null, 8, ["editing-disabled", "agreement-id", "agreement-contact-persons"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "col-4 text-right text-weight-medium self-start" }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_agreements_editable_field_additional_info, {
                          modelValue: _ctx.agreementModel.additionalInfo,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.agreementModel.additionalInfo) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_agreement_update_agreement_management, { agreement: _ctx.agreement }, null, 8, ["agreement"])
        ])
      ])
    ]),
    _createVNode(_component_q_separator, { class: "q-my-lg" }),
    _createElementVNode("div", _hoisted_31, [
      _createVNode(_component_q_btn, {
        label: "Go to List",
        color: "primary",
        onClick: _ctx.onGoToList,
        outline: "",
        unelevated: "",
        "no-caps": ""
      }, null, 8, ["onClick"]),
      _createVNode(_component_q_btn, {
        label: "Back",
        color: "primary",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.go(-1))),
        outline: "",
        unelevated: "",
        "no-caps": ""
      }),
      _createVNode(_component_q_btn, {
        label: "Show Invoices",
        color: "secondary",
        onClick: _ctx.onShowAgreementInvoices,
        unelevated: "",
        "no-caps": ""
      }, null, 8, ["onClick"]),
      _createVNode(_component_q_btn, {
        label: "Download members list as Excel",
        onClick: _ctx.onDownloadMembersListClick,
        disable: _ctx.downloadMemberListDisabled,
        color: "secondary",
        unelevated: "",
        "no-caps": ""
      }, null, 8, ["onClick", "disable"]),
      _createVNode(_component_q_select, {
        modelValue: _ctx.membersModel,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.membersModel) = $event)),
        options: _ctx.membersOptions,
        style: {"width":"250px"},
        outlined: "",
        dense: ""
      }, null, 8, ["modelValue", "options"])
    ])
  ]))
}